module.exports = __webpack_public_path__ + "static/media/links.a2e0b0d2.svg";